export const CUSTOMERS = 'md_customers_GLOBAL';